import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { EmptyFilter, ISubvendorInvoiceList } from "./Table";
import { baseUrl, Fetch } from "../../shared/Fetch";
import React, { useEffect, useRef, useState } from "react";
import { Button } from "primereact/button";
import { ILogin } from "../../models/Login";
import { format } from "date-fns";
import { Filter, InvoiceTrackingFilter } from "./Filter";
import { Accordion, AccordionTab } from "primereact/accordion";
import { MultiInvoiceStatusUpdate } from "./MultiInvoiceStatusUpdate";

interface IProps {
    toast: any;
    setModal: (data: any) => void,
}

export interface ISVInvoiceToUpdatePaymentStatus {
    vendor_Company_ID?: number,
    vendor_Company_Name?: string,
    totalInvoiceAmount?: number,
    invoiceCount?: number
}

export const SVInvoicesToUpdatePaymentStatus = (props: IProps) => {
    const [tableData, setTableData] = useState({ tableData: [], loading: false } as { tableData: ISVInvoiceToUpdatePaymentStatus[], loading: boolean });
    const [openHistory, setOpenHistory] = useState({ id: 0, open: false } as { id: number, open: boolean });
    const [invoiceFilter, setInvoiceFilter] = useState<InvoiceTrackingFilter>(EmptyFilter);
    const [openBulkUpdateSubvendorInvoice, setOpenBulkUpdateSubvendorInvoice] = useState({ singleData: {}, open: false } as { singleData: ISVInvoiceToUpdatePaymentStatus, open: boolean });

    const dt = useRef<DataTable>(null);
    let _roles: Array<number> = [];
    const loginObj: ILogin = JSON.parse(sessionStorage.getItem('auth') + '');
    loginObj.roles.forEach(role => {
        _roles.push(role.role_ID);
    });

    const loadTableData = async (caseType?: string) => {
        setTableData({ tableData: tableData.tableData, loading: true });
        let updateInvoiceFilter: any = invoiceFilter;
        delete updateInvoiceFilter.consultant;

        let query = `filter=${encodeURIComponent(JSON.stringify(updateInvoiceFilter))}`;

        const response = await Fetch("InvoiceTracking/subvendorsInvoicesList", "GET", null, query, props.toast);

        if (response) {
            const data: any[] = await response.json();
            console.log(data);
            setTableData({ tableData: data, loading: false });
            // setSelectedSubvendorInvoices([]);
        } else setTableData({ tableData: tableData.tableData, loading: false });
    };

    const onHideBulkUpdate = () => {
        setOpenBulkUpdateSubvendorInvoice({ open: false, singleData: {} });
        loadTableData();
    }

    useEffect(() => {
        loadTableData();
    }, [invoiceFilter]);

    return (
        <>
            <Accordion>
                <AccordionTab header="Filter">
                    <Filter invoiceFilter={invoiceFilter} setReqFilter={(invoiceFilter: InvoiceTrackingFilter) => setInvoiceFilter(invoiceFilter)} toast={props.toast} byPO_ID={false} inProcess={true} />
                </AccordionTab>
            </Accordion>
            <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0", marginTop: "5px" }}
                ref={dt}
                value={tableData.tableData}
                loading={tableData.loading}
                stripedRows resizableColumns showGridlines columnResizeMode="expand"
                selectionMode="checkbox"
                dataKey="id"
                paginator
                rows={10}
                rowsPerPageOptions={[5, 10, 20]}
            >
                {/* {(invoiceFilter.subVendor_Company !== null && invoiceFilter.subVendor_Company !== undefined) && <Column selectionMode="multiple" />} */}
                <Column header="SN." body={(rowData, options) => options.rowIndex + 1} footer={"Total Amount"} />
                <Column field="vendor_Company_Name" header="Sub Vendor" />
                <Column field="totalInvoiceAmount" header="Total Invoice Amount" footer={() => {
                    const invAmnt = tableData.tableData.reduce((sum, item) => sum + (item?.totalInvoiceAmount || 0), 0);
                    return <span className="">{invAmnt}</span>;
                }} />
                <Column field="invoiceCount" header="Invoice Count" body={(rowData) => <p className="cursor-pointer text-cyan-700 underline" onClick={() => setOpenBulkUpdateSubvendorInvoice({ singleData: rowData, open: true })}>{rowData.invoiceCount}</p>} />
            </DataTable>
            <MultiInvoiceStatusUpdate singleData={openBulkUpdateSubvendorInvoice.singleData} open={openBulkUpdateSubvendorInvoice.open} paymentStatus={invoiceFilter.paymentStatus} hideDialoge={() => onHideBulkUpdate()} toast={props.toast} />
        </>
    );
}